/* @ngInject */
const scrappingRun = (
  $transitions
) => {

}

export default scrappingRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/scrapping.run.js